import React, { useContext, useEffect } from 'react'
import Layout from '../../../components/layout/layout'
import '../mlOutRails/mlOutRails.scss'
import roadmapImage from '../../../images/articles/roadmap-photo.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'


const MlRoadmap = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title='Machine Learning Roadmap: Idea to Production'
        description={translations.BlogMlRoadmap1}
        type='article'
        image={roadmapImage}
        jsonLd={[
          articleJsonLd({
            headline: translations.BlogMlRoadmap,
            description: translations.BlogMlRoadmap1,
            image: roadmapImage,
            path: '/articles/mlRoadmap',
            datePublished: '2026-07-14',
            author: translations.BlogMlRoadmap12,
          }),
          articleBreadcrumbs(translations.BlogMlRoadmap, '/articles/mlRoadmap'),
        ]}
      />
      <div className='mlrole-health-container'>

        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogMlRoadmap}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogMlRoadmap11}</p>
              <p>•</p>
              <p>{translations.BlogMlRoadmap12}</p>
            </div>
            <p className='article-author-head'>{translations.BlogMlRoadmap13}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={roadmapImage} alt='Whiteboard with a week-by-week project roadmap on sticky notes' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='mlRoadmap' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogMlRoadmap1}</p>
              <p>{translations.BlogMlRoadmap2}</p>

              <h2 className='article-secondaty-title'>{translations.BlogMlRoadmap3}</h2>
              <p>{translations.BlogMlRoadmap4}</p>
              <p>{translations.BlogMlRoadmap5}</p>
              <p>{translations.BlogMlRoadmap6}</p>

              <h2 className='article-secondaty-title'>{translations.BlogMlRoadmap7}</h2>
              <p>{translations.BlogMlRoadmap8}</p>
              <p>{translations.BlogMlRoadmap9}</p>
              <p>{translations.BlogMlRoadmap10}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/computerVision' title={translations.BlogComputerVision} />
        </div>
      </div>
    </Layout>
  )
}

export default MlRoadmap
